<!--
    描述： 上传组件
    时间： 2020-03-23
    created by ws
-->
<template>
	<div class="upload-layout">
		<!-- table模式 -->
		<div class="upload-title"
			 v-if="mode !== 'view'">
			<div class="label">文件上传:</div>
			<div class="upload-container">
				<template v-if="isDisabled && fileList.length === 0">暂无附件</template>
				<template v-show="!isDisabled || fileList.length !== 0">
					<el-upload class="upload-demo"
							   ref="upload"
							   action=""
							   :disabled="isDisabled"
							   :limit="maxNum"
							   :multiple="multiple"
							   :on-exceed="onExceed"
							   :on-change="onChange"
							   :show-file-list="false"
							   :auto-upload="false">
						<el-button type="text"><i class="el-icon-upload mr5"></i>点击上传</el-button>
					</el-upload>
				</template>
			</div>
		</div>
		<div class="upload-title"
			 v-if="mode !== 'view'">
			<div class="label"></div>
			<div class="upload-container text-overflow tips-text">
				当前支持文件格式为: {{ acceptMsg }}
			</div>
		</div>
		<div class="upload-table">
			<el-table border
					  :data="tableFile">
				<el-table-column type="index"
								 align="center"
								 header-align="center"
								 label="序号"
								 show-overflow-tooltip
								 width="60">
				</el-table-column>
				<el-table-column prop="name"
								 label="资料名称"
								 align="left"
								 header-align="center"
								 show-overflow-tooltip
								 min-width="230">
					<template slot-scope="scope">
						<span v-if="mode !== 'view'"
							  class="vxe-cell--label">{{ scope.row.fileName }}</span>
						<fileName v-else
								  :fileName="scope.row.fileName"
								  :filePath="scope.row.filePath"
								  :fileSize="scope.row.fileSize"></fileName>
					</template>
				</el-table-column>
				<el-table-column prop="redactUnit"
								 label="文件编制单位"
								 header-align="center"
								 min-width="220">
					<template slot="header"
							  slot-scope="scope">
						文件编制单位
						<el-tooltip effect="light">
							<div slot="content">
								文件编制单位： 所指文件的制作设计单位，<br>
								例如图纸设计方。
							</div>
							<svg-icon icon-class="wenhao"></svg-icon>
						</el-tooltip>
					</template>
					<template slot-scope="scope">
						<template v-if="!scope.row.id">
							<el-input size="small"
									  maxlength="50"
									  show-word-limit
									  v-model="scope.row.redactUnit"></el-input>
						</template>
						<template v-else>{{ scope.row.redactUnit }}</template>
					</template>
				</el-table-column>
				<el-table-column prop="createUser"
								 label="上传人"
								 width="180"
								 align="center"
								 header-align="center"
								 show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="upUnit"
								 label="上传单位"
								 width="200"
								 align="center"
								 header-align="center"></el-table-column>
				<el-table-column prop="createDate"
								 label="上传时间"
								 width="180"
								 align="center"
								 header-align="center"
								 show-overflow-tooltip>
				</el-table-column>
				<el-table-column label="操作"
								 width="90"
								 align="center"
								 v-if="mode !== 'view'"
								 header-align="center"
								 show-overflow-tooltip>
					<template slot-scope="scope">
						<el-button class="table-btn"
								   size="mini"
								   round
								   plain
								   type="danger"
								   :disabled="handleDis(scope.row)"
								   icon="el-icon-delete"
								   @click="tableDelete(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<!-- 上传进度 -->
		<el-dialog title="上传进度"
				   width="65%"
				   class="progressDialog"
				   :visible.sync="progressData.show"
				   :close-on-click-modal="false"
				   :close-on-press-escape="false"
				   :show-close="progressData.close"
				   :append-to-body="true"
				   @close="progressClose">
			<div>
				<el-row v-for="(i, index) in progressData.eventList"
						:key="'eventList' + index">
					<el-col :span="8">
						<div class="inputTitle">
							{{ i.name }}
						</div>
					</el-col>
					<el-col :span="16">
						<el-row class="progressBox"
								:gutter="20">
							<el-col :span="10"
									class="progressCol">
								<el-progress :text-inside="true"
											 :stroke-width="26"
											 :percentage="i.progress"></el-progress>
							</el-col>
							<el-col :span="12"
									class="progressInfo">
								{{ i.progressInfo }}&nbsp;
								<i class="el-icon-loading"
								   v-show="i.progressLoading"></i>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import * as API from '@/api/modules/upload'
import { dateFormat } from '@/utils/tools'
import { mapState } from 'vuex'
import fileName from '@/components/file/fileName'
export default {
	name: 'upload_component',
	components: { fileName },
	props: {
		// 当前查看模式
		mode: {
			type: String,
			default: 'add',
		},
		// 最大文件上传个数
		maxNum: {
			type: Number,
			default: 10,
		},
		// 是否支持多选
		multiple: {
			type: Boolean,
			default: true,
		},
		// 接收的文件类型
		acceptType: {
			type: Array,
			default: () => {
				return []
			},
		},
		// 回显业务表id
		aid: {
			type: String,
			default: '',
		},
		// 业务表名称
		tableName: {
			type: String,
			default: 'bus_project_file',
		},
		// 业务表名称
		assortment: {
			type: String,
			default: 'bus_project_file',
		},
	},
	data() {
		return {
			fileList: [],
			addList: [],
			delList: [],
			isDisabled: false, // 是否禁用
			isLoaded: false,
			progressData: {
				show: false,
				close: false,
				eventList: [],
			},
			progressOverWatch: null,
		}
	},
	created() {
		// 判断是否有数据表ID
		this.aid !== '' ? this.getFiles() : ''
	},
	mounted() {
		// 组件加载完毕后 渲染状态
		this.isLoaded = true
	},
	methods: {
		// 文件列表变化事件
		onChange(file, fileList) {
			let curType = file.name.substring(file.name.lastIndexOf('.') + 1)
			if (this.checkType(curType)) {
				// 如果不存在id 是添加情况
				if (!file.id) {
					// 进度条相关
					this.progressData.eventList = []
					fileList.map((i) => {
						if (!i.id) this.progressData.eventList.push(i)
					})
					this.progressData.eventList.map((i) => {
						i.progress = 0
						i.progressLoading = true
					})
					let obj = {
						fileName: file.name,
						unit: '', //文件编制单位
						uid: file.uid,
						createUser: this.userInfo.sname,
						upUnit: this.userInfo.deptName,
						deptId: this.userInfo.deptId,
						createDate: this.$utils.toDateString(
							new Date(),
							'yyyy-MM-dd HH:mm:ss'
						),
						file: file.raw,
						type: '0',
					}
					this.addList.push(obj)
				}
			} else {
				this.doDelete(file)
			}
		},

		// 文件上传方法 --- 上传数据库
		fileUpload(uploadId, item, params, projectId, index) {
			// 在有上传数据的情况下
			let _aid = uploadId ? uploadId : this.aid

			let dataParams = {
				path: params.path,
				size: params.size,
				aid: _aid,
				tableName: this.tableName,
				assortment: this.assortment,
				source: '1',
				projectId: projectId,
				type: '0',
				busId: _aid,
				upUnit: item.upUnit,
				redactUnit: item.redactUnit,
				deptId: item.deptId,
			}

			API.saveFile(dataParams)
				.then((res) => {
					this.progressData.eventList[index].progressInfo = '上传成功'
					this.progressData.eventList[index].progressLoading = false
				})
				.catch((err) => {
					if (this.progressData.eventList.length > 0) {
						this.progressData.eventList[index].progressInfo =
							'上传失败, 请关闭后重试'
						this.progressData.eventList[
							index
						].progressLoading = false
					}
				})
		},

		// 文件上传到服务器
		fileSend(aid, projectId, callBackFn, errorFn, fileInfo) {
			// 进度条相关
			if (fileInfo) {
				this.progressData.eventList = fileInfo.fileList
				this.progressData.eventList.map((i) => {
					i.progress = 0
					i.progressLoading = true
				})
			}

			this.progressOverWatch = setInterval(() => {
				let over = true
				this.progressData.eventList.map((i) => {
					if (i.progressLoading) {
						over = false
					}
				})
				if (over) {
					this.progressData.show = false
					this.progressData.eventList = []
					clearInterval(this.progressOverWatch)
					if (callBackFn) {
						setTimeout(() => {
							callBackFn()
						}, 1000)
					}
				}
			}, 500)

			// 附件信息
			let that = this
			let arr = this.tableFile.filter((x) => !x.id)
			if (arr.length > 0) {
				return new Promise((resolve, reject) => {
					for (let [i, item] of arr.entries()) {
						let formData = new FormData()
						formData.append('file', item.file)
						formData.append('path', dateFormat('yyyy-mm-dd'))
						formData.append('output', 'json')
						that.progressData.show = true
						API.uploadToWeb(formData, that.progressFn, i)
							.then((res) => {
								that.fileUpload(aid, item, res, projectId, i)

								resolve(true)
							})
							.catch((err) => {
								that.$message.error('附件上传服务器失败！')
								that.progressData.close = true
								reject(false)
							})
					}
				})
			} else {
				if (callBackFn) {
					callBackFn()
				}
			}
		},

		// 上传进度函数
		progressFn(progressEvent, index) {
			if (this.progressData.eventList.length > 0) {
				this.progressData.eventList[index].progress =
					((progressEvent.loaded / progressEvent.total) * 100) | 0
				if (this.progressData.eventList[index].progress === 100) {
					this.progressData.eventList[index].progressInfo =
						'正在合并文件并等待服务器回应, 请稍后....'
				} else {
					this.progressData.eventList[index].progressInfo = '正在上传'
				}
				let data = this.progressData.eventList[index]
				this.$set(this.progressData.eventList, index, data)
			}
		},

		// 进度条弹窗关闭
		progressClose() {
			this.progressData.close = false
		},

		// 数据回显
		getFiles() {
			API.getFiles({
				aid: this.aid,
				tableName: this.tableName,
				assortment: this.assortment,
				type: '0',
				source: '1',
			}).then((res) => {
				this.fileList = res.data
			})
		},

		// 检测所选文件是否符合格式
		checkType(curType) {
			if (this.acceptType.length > 0) {
				if (this.acceptType.find((x) => x === curType)) {
					return true
				} else {
					this.$message.error('文件格式不对，请重新选择!')
					return false
				}
			} else {
				return true
			}
		},

		// 文件超出最大个数事件
		onExceed() {
			this.$message.warning('当前最多可上传' + this.maxNum + '个文件！')
		},

		// 查看文件
		doView(file) {
			fileView(file.id)
		},

		// 删除文件
		doDelete(file) {
			let _index = this.$refs.upload.uploadFiles.findIndex(
				(x) => x.uid === file.uid
			)
			// 如果有ID 弹窗提示
			if (file.id) {
				this.$confirm('确认要删除当前附件吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				})
					.then(() => {
						this.delList.push(file.id)
						this.$refs.upload.uploadFiles.splice(_index, 1)
						this.$message.info('移除成功，保存后生效!')
					})
					.catch(() => {})
			} else {
				// 否则直接删除
				this.addList.splice(
					this.addList.findIndex((x) => x.uid === file.uid),
					1
				)
				this.$refs.upload.uploadFiles.splice(_index, 1)
			}
		},

		// 清除文件列表
		clearFiles() {
			this.$refs.upload.clearFiles()
			this.addList = []
			this.delList = []
		},

		// table 模式上传后就不准删除（仅用于规划图）
		handleDis(data) {
			if (this.noDelete) {
				return !!data.id
			}
			return false
		},

		// 删除文件
		tableDelete(file) {
			let _index = this.tableFile.findIndex((x) => x.uid === file.uid)
			// 如果有ID 弹窗提示
			if (file.id) {
				this.$confirm('确认要删除当前附件吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				})
					.then(() => {
						API.deleteFiles({ id: file.fileSummaryId })
							.then((res) => {
								this.$message.success('删除成功!')
								this.$refs.upload.uploadFiles.splice(_index, 1)
								this.fileList.splice(
									this.fileList.findIndex(
										(x) => x.id === file.id
									),
									1
								)
								this.addList.splice(
									this.addList.findIndex(
										(x) => x.id === file.id
									),
									1
								)
							})
							.catch((err) => {})
					})
					.catch(() => {})
			} else {
				// 否则直接删除
				this.addList.splice(
					this.addList.findIndex((x) => x.uid === file.uid),
					1
				)
				this.$refs.upload.uploadFiles.splice(_index, 1)
			}
		},
	},
	computed: {
		...mapState('user', {
			userInfo: (state) => state.userInfo,
		}),

		// 当前文件列表数量
		fileLength() {
			if (!this.isLoaded) {
				return 0
			}
			return this.$refs.upload.uploadFiles.length
		},

		// 支持的文件格式 文字
		acceptMsg() {
			return this.acceptType.length > 0
				? JSON.stringify(this.acceptType)
				: '所有格式文件'
		},

		tableFile() {
			let arr = this.$utils.clone(this.fileList, true)
			let arr1 = this.$utils.clone(this.addList, true)
			arr = arr.concat(arr1)
			return arr
		},
	},
}
</script>

<style lang="less">
.upload-layout {
	text-align: left;
	.file-item {
		display: flex;
		justify-content: space-between;
		padding: 0 5px;
		.item-left {
			width: 80%;
			padding: 0 5px;
			box-sizing: border-box;
		}
		.item-right {
			width: 20%;
			text-align: right;
			em {
				cursor: pointer;
			}
		}
	}
	.file-tip {
		margin-top: 0;
		height: 35px;
		line-height: 35px;
	}
	.el-upload {
		display: unset;
		text-align: left;
	}
	.upload-title {
		height: 36px;
		line-height: 36px;
		display: flex;
		font-size: 14px;
		color: #606266;

		.label {
			width: 80px;
			text-align: left;
		}

		.tips-text {
			font-size: 12px;
		}

		.upload-container {
			flex: 1;
		}

		.el-upload {
			text-align: left;
		}
	}
}
</style>